import { SVGProps } from "react"

const Floor2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.5 17H20.7222"
      stroke={props.color || "black"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.83203 17V12.3333H7.4987V7.66667H12.1654V3H16.832V17"
      stroke={props.color || "black"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Floor2Icon
